export const SOFTLINE_API_WWS_EINHEITENEINGABE = '/v1/wws/einheiteneingabe/{{id}}'
export const SOFTLINE_API_WWS_EINHEITENEINGABE_UMRECHNEN = '/v1/wws/einheiteneingabe/umrechnen'
